import { createAction, props } from '@ngrx/store';
import { SharedEntity } from '../models/shared.models';

//-- User Session Data
export const loadUserSession = createAction(
  '[SkyMiles Shared] Load User Session'
);

export const loadUserSessionSuccess = createAction(
  '[SkyMiles Shared] Load User Session Success',
  props<{ session: SharedEntity }>()
);

export const loadUserSessionFailure = createAction(
  '[SkyMiles Shared] Load User Session Failure',
  props<{ error: SharedEntity }>()
);
